import { useEffect } from 'react';

/**
 * Hook to fix accessibility issues with Amplify UI components
 * This hook removes aria-hidden attributes from elements that contain focus
 */
const useAccessibilityFix = () => {
  useEffect(() => {
    // Function to fix aria-hidden attributes
    const fixAriaHidden = () => {
      // Remove any aria-hidden attributes from the document root
      const rootElement = document.getElementById('root');
      if (rootElement) {
        rootElement.removeAttribute('aria-hidden');
      }
      
      // Remove aria-hidden from any element containing focus
      document.querySelectorAll('[aria-hidden="true"]').forEach(el => {
        if (el.contains(document.activeElement)) {
          el.removeAttribute('aria-hidden');
        }
      });
    };

    // Run the fix immediately
    fixAriaHidden();
    
    // Set up a mutation observer to watch for changes to the DOM
    const observer = new MutationObserver((mutations) => {
      let shouldFix = false;
      
      // Check if any mutations involve aria-hidden attributes
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          shouldFix = true;
        }
      });
      
      if (shouldFix) {
        fixAriaHidden();
      }
    });
    
    // Start observing the document
    observer.observe(document.body, {
      attributes: true,
      subtree: true,
      attributeFilter: ['aria-hidden']
    });
    
    // Clean up the observer when the component unmounts
    return () => {
      observer.disconnect();
    };
  }, []);
};

export default useAccessibilityFix;
